import { Box, Button, Card, Divider, Grid, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import api from "../../../components/services/api";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { Link } from "react-router-dom";
import { useParams } from "react-router";

export default function EditShipSchedule() {
  const { id } = useParams();
  const [shipHeadList, setShipHeadList] = useState({});

  const [value, setValue] = useState("1");

  const [ShipHeadListOut, setShipHeadListOut] = useState({});
  const [page, setPage] = useState({});

  const getShipVoyInDetail = async () => {
    try {
      const result = await api.get("api/ship/detail/" + id);
      const _result = result.data;
      setPage(_result.page);
      setShipHeadList(_result.Inbound);
      setShipHeadListOut(_result.Outbound);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    getShipVoyInDetail();
  }, []);

  const handkeClickcon = () => {};

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          maxHeight: "86vh",
          overflow: "auto",
        }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          แผนตารางเรือ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Ship Planning
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Ship </Typography>
            <Typography>
              <span>&nbsp;</span> / Ship Planning
            </Typography>
          </Grid>
        </Grid>

        <form>
          <Grid sx={{ padding: "40px 70px 40px 70px" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <div style={{ display: "flex", gap: "15px" }}>
                {page?.previousPage && <a href={`/Planner/EditShipSchedule/${page.previousPage}`}>
                  <Button
                    style={{
                      backgroundColor: "#007bff",
                      color: "#fafafa",
                      display: "flex",
                      justifyContent: "center",
                      marginRight: "10px",
                    }}
                  >
                    {`< Previous`}
                  </Button>
                </a>}
                {page?.nextPage && <a href={`/Planner/EditShipSchedule/${page?.nextPage}`}>
                  <Button
                    style={{
                      backgroundColor: "#007bff",
                      color: "#fafafa",
                      display: "flex",
                      justifyContent: "center",
                      marginRight: "10px",
                    }}
                  >
                    {`Next >`}
                  </Button>
                </a>}
              </div>
            </div>

            <TabContext value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", marginTop: 5 }}
              >
                <TabList
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: { backgroundColor: "transparent" },
                  }}
                >
                  <Tab
                    sx={{
                      "&.Mui-selected": {
                        background: "#80C340",
                        color: "white",
                        borderTopLeftRadius: "15px",
                        borderTopRightRadius: "15px",
                      },
                    }}
                    label={shipHeadList?.Voyage}
                    value="1"
                  />
                  <Tab
                    sx={{
                      "&.Mui-selected": {
                        background: "#80C340",
                        color: "white",
                        borderTopLeftRadius: "15px",
                        borderTopRightRadius: "15px",
                      },
                    }}
                    label={ShipHeadListOut?.Voyage}
                    value="2"
                  />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Grid container rowSpacing={2} columnSpacing={2}>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "rows",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        className="material-icons-outlined textcolorBule"
                        style={{ fontSize: 30 }}
                      >
                        directions_boat
                      </span>
                      <h5
                        className="textcolorBule"
                        style={{ margin: "0px 10px" }}
                      >
                        {setShipHeadList?.Voyage}
                      </h5>

                      <span
                        className="textcolorBule"
                        style={{
                          alignSelf: "start",
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      >
                        |
                      </span>
                      <span className="textcolorBule" style={{ marginLeft: 5 }}>
                        TONS:
                        <span
                          style={{
                            margin: "0px 10px 0px 10px",
                            color: "black",
                          }}
                        >
                          {+shipHeadList.Weight / 1000}/
                          {+shipHeadList.MaxWeight / 1000}
                        </span>
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "rows",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span className="textcolorBule">TEUS:</span>
                      <span style={{ margin: "0px 10px 0px 10px" }}>
                        {shipHeadList.Teus}/{shipHeadList.MaxTeus}
                      </span>
                      <span className="textcolorBule">LOADING PERCENTAGE:</span>
                      <span style={{ margin: "0px 10px 0px 10px" }}>
                        {shipHeadList.LoadingPercentage?.toFixed(2)}%
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Link
                        to={{
                          pathname: `/Ship/Cost/${shipHeadList?.Voyage}/${shipHeadList.BargeId}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "center",
                            marginRight: "10px",
                          }}
                        >
                          Cost
                        </Button>
                      </Link>
                      <Link
                        to={{
                          pathname: `/Ship/detailContainerTally/${shipHeadList?.Voyage}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#80C340",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "10px",
                          }}
                        >
                          Container Tally
                        </Button>
                      </Link>
                      <Link
                        to={{
                          pathname: `/Ship/Plan/${shipHeadList?.Voyage}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "rgb(235 62 150)",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          Plan
                        </Button>
                      </Link>
                    </div>
                  </Grid>
                </Grid>
                <table
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // border: "1px solid #e0e0e0",
                    marginTop: 40,
                  }}
                >
                  <thead
                    style={{
                      height: 50,
                      backgroundColor: "#30318D",
                      color: "white",
                    }}
                  >
                    <tr>
                      <th>BARGE</th>
                      <th>TUG </th>
                      <th>VOY</th>
                      <th>ETD</th>
                      <th>ETA</th>
                      <th>From - To</th>
                    </tr>
                  </thead>
                  <tr>
                    <td>{shipHeadList?.BargeName}</td>
                    <td>{shipHeadList?.TugName}</td>
                    <td>{shipHeadList?.Voyage}</td>
                    <td>
                      {moment(shipHeadList?.ETDIn).format("YYYY-MM-DD h:mm")}
                    </td>
                    <td>
                      {moment(shipHeadList?.ETAIn).format("YYYY-MM-DD h:mm")}
                    </td>
                    <td>
                      {shipHeadList?.LocationFrom} - {shipHeadList?.LocationTo}
                    </td>
                  </tr>
                  {/* <tbody>
                    {shipHeadList?.map((Data, index) => {
                      return (
                        <tr>
                          <td>{Data.BargeName}</td>
                          <td>{Data.TugName}</td>
                          <td>{Data.Voyage}</td>
                          <td>{moment(Data.ETAIn).format("YYYY-MM-DD")}</td>
                          <td>{moment(Data.ETDIn).format("YYYY-MM-DD")}</td>
                          <td>
                            {Data.LocationFrom}-{Data.LocationTo}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody> */}
                </table>
                <Divider sx={{ marginBottom: 5, marginTop: 5 }} />

                <Box
                  className="Flipped"
                  sx={{ marginTop: "10px", overflowX: "auto" }}
                >
                  <table
                    className="Content"
                    style={{
                      width: "200%",
                      textAlign: "center",
                      // border: "1px solid #e0e0e0",
                    }}
                  >
                    <thead
                      style={{
                        height: 50,
                        backgroundColor: "#80C340",
                        color: "white",
                      }}
                    >
                      <tr>
                        <th>VOY IN</th>
                        <th>VOY OUT</th>
                        <th>REF NO.</th>
                        <th>SO NO.</th>
                        <th>BOOKING NO.</th>
                        <th>TYPE</th>
                        <th>QTY</th>
                        <th>COMMODITY</th>
                        <th>PACKAGE</th>
                        <th>LINERS</th>
                        <th>FREIGHT</th>
                        <th>STUFFING</th>
                        <th>CLOSING</th>
                        <th>ETD POL</th>
                        <th>TERMINAL</th>
                        <th>FEEDER</th>
                        <th>STATUS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shipHeadList?.Detail?.map((data, index) => {
                        return (
                          <tr>
                            <td>
                              {data?.InboundVoyNo || ""}{" "}
                              {data?.InboundVoyNo_2 || ""}{" "}
                              {data?.InboundVoyNo_3 || ""}
                            </td>
                            <td>
                              {data?.OutboundVoyNo || ""}{" "}
                              {data?.OutboundVoyNo_2 || ""}{" "}
                              {data?.OutboundVoyNo_3 || ""}
                            </td>
                            <td>{data?.ShipperRefNo}</td>
                            <td>
                              <Link
                                to={
                                  "/CustomerSupport/EditSaleOrder/" +
                                  data?.SaleOrderId
                                }
                              >
                                {data?.SaleOrderNo}
                              </Link>
                            </td>
                            <td>{data?.BookingNo}</td>
                            <td>{data?.ContainerStockType}</td>
                            <td>{data?.Quantity}</td>
                            <td>{data?.Commodity}</td>
                            <td>{data?.Package}</td>
                            <td>{data?.Liners}</td>
                            <td>{data?.FreightForwarder}</td>
                            <td>{data?.Stuffing}</td>
                            <td>{data?.ClosingDate}</td>
                            <td>{data?.ETDPOLDate}</td>
                            <td>{data?.Terminal}</td>
                            <td>{data?.FeederVessel}</td>
                            {/* <td>{data?.Remark || ""}</td> */}

                            <td>
                              {data?.SaleOrderStatus === null
                                ? null
                                : data?.SaleOrderStatus == 1
                                ? "New"
                                : data?.SaleOrderStatus == 2
                                ? "Processing"
                                : data?.SaleOrderStatus == 3
                                ? "AssignToPlanner"
                                : data?.SaleOrderStatus == 4
                                ? "AssignToCy"
                                : data?.SaleOrderStatus == 5
                                ? "Confirm"
                                : data?.SaleOrderStatus == 6
                                ? "AssigntoDocument"
                                : data?.SaleOrderStatus == 7
                                ? "AssigntoAdmin"
                                : data?.SaleOrderStatus == 8
                                ? "Complete"
                                : "Cancle"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </TabPanel>

              <TabPanel value="2">
                <Grid container rowSpacing={2} columnSpacing={2}>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "rows",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        className="material-icons-outlined textcolorBule"
                        style={{ fontSize: 30 }}
                      >
                        directions_boat
                      </span>
                      <h5
                        className="textcolorBule"
                        style={{ margin: "0px 10px" }}
                      >
                        {setShipHeadListOut?.Voyage}
                      </h5>

                      <span
                        className="textcolorBule"
                        style={{
                          alignSelf: "start",
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      >
                        |
                      </span>
                      <span className="textcolorBule" style={{ marginLeft: 5 }}>
                        TONS:
                        <span
                          style={{
                            margin: "0px 10px 0px 10px",
                            color: "black",
                          }}
                        >
                          {+ShipHeadListOut?.Weight / 1000}/
                          {+ShipHeadListOut?.MaxWeight / 1000}
                        </span>
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "rows",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span className="textcolorBule">TEUS:</span>
                      <span style={{ margin: "0px 10px 0px 10px" }}>
                        {ShipHeadListOut.Teus}/{ShipHeadListOut.MaxTeus}
                      </span>
                      <span className="textcolorBule">LOADING PERCENTAGE:</span>
                      <span style={{ margin: "0px 10px 0px 10px" }}>
                        {ShipHeadListOut?.LoadingPercentage?.toFixed(2)}%
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    alignItems="center"
                    xs={12}
                    md={12}
                    lg={4}
                    sx={{
                      flexDirection: "rows",
                      display: "flex",
                      alightItem: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Link
                        to={{
                          pathname: `/Ship/Cost/${ShipHeadListOut?.Voyage}?BrageId=${ShipHeadListOut?.BrageId}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "center",
                            marginRight: "10px",
                          }}
                        >
                          Cost
                        </Button>
                      </Link>
                      <Link
                        to={{
                          pathname: `/Ship/detailContainerTally/${ShipHeadListOut?.Voyage}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#80C340",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "10px",
                          }}
                        >
                          Container Tally
                        </Button>
                      </Link>
                      <Link
                        to={{
                          pathname: `/Ship/Plan/${ShipHeadListOut?.Voyage}`,
                        }}
                      >
                        <Button
                          style={{
                            backgroundColor: "rgb(235 62 150)",
                            color: "#fafafa",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          Plan
                        </Button>
                      </Link>
                    </div>
                  </Grid>
                </Grid>
                <table
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // border: "1px solid #e0e0e0",
                    marginTop: 40,
                  }}
                >
                  <thead
                    style={{
                      height: 50,
                      backgroundColor: "#30318D",
                      color: "white",
                    }}
                  >
                    <tr>
                      <th>BARGE</th>
                      <th>TUG </th>
                      <th>VOY</th>
                      <th>ETD</th>
                      <th>ETA</th>
                      <th>From - To</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{ShipHeadListOut.BargeName}</td>
                      <td>{ShipHeadListOut.TugName}</td>
                      <td>{ShipHeadListOut.Voyage}</td>
                      <td>
                        {moment(ShipHeadListOut.ETDOut).format(
                          "YYYY-MM-DD h:mm"
                        )}
                      </td>
                      <td>
                        {moment(ShipHeadListOut.ETAOut).format(
                          "YYYY-MM-DD h:mm"
                        )}
                      </td>

                      <td>
                        {ShipHeadListOut.LocationFrom}-
                        {ShipHeadListOut.LocationTo}
                      </td>
                    </tr>
                  </tbody>
                  {/* <tbody>
                    {ShipHeadListOut?.map((Data, index) => {
                      return (
                        <tr>
                          <td>{Data.BargeName}</td>
                          <td>{Data.TugName}</td>
                          <td>{Data.Voyage}</td>
                          <td>{moment(Data.ETAIn).format("YYYY-MM-DD")}</td>
                          <td>{moment(Data.ETDIn).format("YYYY-MM-DD")}</td>
                          <td>
                            {Data.LocationFrom}-{Data.LocationTo}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody> */}
                </table>
                <Divider sx={{ marginBottom: 5, marginTop: 5 }} />

                <Box
                  className="Flipped"
                  sx={{ marginTop: "10px", overflowX: "auto" }}
                >
                  <table
                    className="Content"
                    style={{
                      width: "200%",
                      textAlign: "center",
                      // border: "1px solid #e0e0e0",
                    }}
                  >
                    <thead
                      style={{
                        height: 50,
                        backgroundColor: "#80C340",
                        color: "white",
                      }}
                    >
                      <tr>
                        <th>VOY IN</th>
                        <th>VOY OUT</th>
                        <th>REF NO.</th>
                        <th>SO NO.</th>
                        <th>BOOKING NO.</th>
                        <th>TYPE</th>
                        <th>QTY</th>
                        <th>COMMODITY</th>
                        <th>PACKAGE</th>
                        <th>LINERS</th>
                        <th>FREIGHT</th>
                        <th>STUFFING</th>
                        <th>CLOSING</th>
                        <th>ETD POL</th>
                        <th>TERMINAL</th>
                        <th>FEEDER</th>
                        <th>STATUS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ShipHeadListOut?.Detail?.map((data, index) => {
                        return (
                          <tr>
                            <td>
                              {data?.InboundVoyNo || ""}{" "}
                              {data?.InboundVoyNo_2 || ""}{" "}
                              {data?.InboundVoyNo_3 || ""}
                            </td>
                            <td>
                              {data?.OutboundVoyNo || ""}{" "}
                              {data?.OutboundVoyNo_2 || ""}{" "}
                              {data?.OutboundVoyNo_3 || ""}
                            </td>
                            <td>{data?.ShipperRefNo}</td>
                            <td>
                              <Link
                                to={
                                  "/CustomerSupport/EditSaleOrder/" +
                                  data?.SaleOrderId
                                }
                              >
                                {data?.SaleOrderNo}
                              </Link>
                            </td>
                            <td>{data?.BookingNo}</td>
                            <td>{data?.ContainerStockType}</td>
                            <td>{data?.Quantity}</td>
                            <td>{data?.Commodity}</td>
                            <td>{data?.Package}</td>
                            <td>{data?.Liners}</td>
                            <td>{data?.FreightForwarder}</td>
                            <td>{data?.Stuffing}</td>
                            <td>{data?.ClosingDate}</td>
                            <td>{data?.ETDPOLDate}</td>
                            <td>{data?.Terminal}</td>
                            <td>{data?.FeederVessel}</td>
                            {/* <td>{data?.Remark || ""}</td> */}

                            <td>
                              {data?.SaleOrderStatus === null
                                ? null
                                : data?.SaleOrderStatus == 1
                                ? "New"
                                : data?.SaleOrderStatus == 2
                                ? "Processing"
                                : data?.SaleOrderStatus == 3
                                ? "AssignToPlanner"
                                : data?.SaleOrderStatus == 4
                                ? "AssignToCy"
                                : data?.SaleOrderStatus == 5
                                ? "Confirm"
                                : data?.SaleOrderStatus == 6
                                ? "AssigntoDocument"
                                : data?.SaleOrderStatus == 7
                                ? "AssigntoAdmin"
                                : data?.SaleOrderStatus == 8
                                ? "Complete"
                                : "Cancle"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </TabPanel>
            </TabContext>
          </Grid>
        </form>
      </Card>
    </div>
  );
}
